import { Stack, styled } from '@mui/joy';

interface IProps {
  isDragReject: boolean;
}

const propsToSkip = ['isDragReject'];
const shouldForwardProp = (prop: string) => !propsToSkip.includes(prop);

export const Wrapper = styled(Stack, {
  shouldForwardProp,
})<IProps>(({ theme, isDragReject }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: '100%',
  height: '100%',
  borderRadius: 6,
  border: `2px dashed ${theme.palette.primary[300]}`,
  backgroundColor: theme.palette.background.level1,
  cursor: 'pointer',

  ...(isDragReject && {
    borderColor: theme.palette.danger[500],
    backgroundColor: theme.palette.danger[100],
  }),
}));
